'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

export const LoadingLink = ({ href, children, className, style, onLoadingChange }) => {
  const pathname = usePathname();

  const handleClick = () => {
    // Clicking a link to the page you're already on won't trigger a pathname
    // change, so the loader would never clear itself — skip showing it.
    if (href === pathname) return;
    onLoadingChange(true);
  };

  return (
    <Link href={href} className={className} style={style} onClick={handleClick}>
      {children}
    </Link>
  );
};